export default __webpack_public_path__ + "static/media/detail_0.c76c236f.jpg";